(() => {
  'use strict';

  const PAGE_PATH = '/pages/custom-server-builds';
  const PENDING_KEY = 'gpused-server-build:pending:v1';
  const REPORTED_PREFIX = 'gpused-server-build:reported:v1:';
  const EVENT_NAME = 'gpused:server_build_enquiry_submitted';

  function storage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function attemptId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (error) {
      // Measurement must not interrupt the contact form.
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function trackConfirmedSuccess(root) {
    if (root.dataset.serverSuccessMeasured === 'true') return;
    root.dataset.serverSuccessMeasured = 'true';

    const currentStorage = storage();
    let pending = '';
    try {
      pending = currentStorage?.getItem(PENDING_KEY) || '';
    } catch (error) {
      // The Shopify-rendered success state remains authoritative.
    }
    const reportedKey = REPORTED_PREFIX + (pending || 'unattributed');
    try {
      if (currentStorage?.getItem(reportedKey)) return;
    } catch (error) {
      // In-memory initialisation still avoids duplicate events on this page load.
    }

    let retries = 0;
    function publishWhenReady() {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') {
        if (retries++ < 10) window.setTimeout(publishWhenReady, 500);
        return;
      }

      try {
        Promise.resolve(analytics.publish(EVENT_NAME, {
          event_version: 1,
          confirmation: 'shopify-rendered-success',
          form_kind: 'enterprise_server_build',
          page_path: PAGE_PATH,
        })).then((published) => {
          if (published === false) return;
          try {
            currentStorage?.setItem(reportedKey, 'published');
          } catch (error) {
            // Storage restrictions affect deduplication, never form delivery.
          }
        }).catch(() => {});
      } catch (error) {
        // Analytics failures must not change the confirmed customer response.
      }
    }
    publishWhenReady();
  }

  function initialise() {
    if (window.location.pathname !== PAGE_PATH) return;
    document.querySelectorAll('[data-gpused-server-config]').forEach((root) => {
      const success = root.querySelector('[data-gpused-server-success]');
      if (success) {
        trackConfirmedSuccess(success);
        return;
      }

      const form = root.querySelector('form.gpused-server-config__form');
      if (!form || form.dataset.serverMeasurementInitialised === 'true') return;
      form.dataset.serverMeasurementInitialised = 'true';
      form.addEventListener('submit', () => {
        try {
          storage()?.setItem(PENDING_KEY, attemptId());
        } catch (error) {
          // Native Shopify submission is never blocked by measurement.
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();
